/**
 * Permet de vérifier la permission d'un objet
 * en fonction du role de l'agent
 * afin de cacher l'objet si pas de permission
 */
import store from '../store'
import {NO_PEONS, NO_AGENTS, NO_ADMINS, NO_PEONS_NOR_AGENTS} from '../constants'
import _ from 'lodash'
export default {
  methods: {
    checkPermission (roles) {
      if (roles === 'NO_ADMINS') {
        return (_.indexOf(NO_ADMINS, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_AGENTS') {
        return (_.indexOf(NO_AGENTS, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_PEONS') {
        return (_.indexOf(NO_PEONS, store.getters['_User/account'].role) !== -1)
      } else if (roles === 'NO_PEONS_NOR_AGENTS') {
        return (_.indexOf(NO_PEONS_NOR_AGENTS, store.getters['_User/account'].role) !== -1)
      }
    }
    /* checkLevelAndOption (section) {
      if (roles === 'ciblage') {
        return (_.indexOf(NO_ADMINS, store.getters['_User/account'].role) !== -1)
      }
    } */
  }
}



// WEBPACK FOOTER //
// ./src/mixins/permissions.js